import { Component, OnInit } from '@angular/core';
import { PatientContext } from 'app/mpi/lib/patient/services/patient-context';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { ClinicalDocumentService } from 'app/integration/document/services/clinical-document.service';
import { CodeSystemConcept } from 'app/mdm/terminology-lib/services/codesystem';
import { serializeLocalDate } from '@heda/core-util';
import { ReferralService } from 'app/reception/lib/services/referral/referral-service';
import { ReferralExternalSearchParams } from 'app/reception/lib/services/referral/referral-external-search-params';
import { Referral } from 'app/reception/lib/services/referral/referral';
import { asPipe } from '@heda/core-util/util/pipe.util';

@Component({
  selector: 'hw-e-consultation-list',
  templateUrl: './e-consultation-list.component.html',
})
export class EConsultationListComponent implements OnInit {
  public loading = false;
  public params = new ReferralExternalSearchParams();
  public referrals: Referral[] = [];
  public speciality: string;
  public saveInProgress: boolean;

  public onlyTis(concept: CodeSystemConcept): boolean {
    return concept.attributes['tisCode'];
  }

  constructor(
    public patientContext: PatientContext,
    private route: ActivatedRoute,
    private referralService: ReferralService,
    private documentService: ClinicalDocumentService,
    private router: Router
  ) {}

  public ngOnInit(): void {
    this.emptyFilter();
    const speciality = this.route.snapshot.paramMap.get('speciality');
    if (speciality) {
      this.speciality = speciality;
      this.search();
    }
  }

  public search(): void {
    this.loading = true;
    this.params.code = ['e-visit'];
    this.params.onlyOrgReferrals = true;
    if (!this.params.validTo) {
      this.params.validTo = new Date();
    }
    if (!this.params.validFrom) {
      this.params.validFrom = moment(this.params.validTo).subtract(29, 'day').startOf('day').toDate();
    }
    this.params.validFrom = serializeLocalDate(this.params.validFrom);
    this.params.validTo = serializeLocalDate(this.params.validTo);
    this.referralService.searchExternal(this.params).subscribe({
      next: (resp) => {
        this.referrals = this.speciality
          ? resp.filter((r) => r.performer.practitioner?.speciality?.code === this.speciality)
          : resp;
        this.loading = false;
      },
      error: () => {
        this.referrals = [];
        this.loading = false;
      },
    });
  }

  public emptyFilter(): void {
    this.speciality = null;
    this.params = new ReferralExternalSearchParams();
    const date = moment().startOf('day');
    this.params.validTo = date.endOf('day').toDate();
    this.params.validFrom = date.subtract(29, 'day').startOf('day').toDate();
    this.params.status = 'active';
  }

  public openDocument(referral: Referral): void {
    this.documentService.openDocument('e-visit', referral.identifier, referral.subject.identifiers[0]);
  }

  public respond(referral: Referral): void {
    this.saveInProgress = true;
    this.referralService.saveExternal(referral).subscribe((ref) => {
      this.saveInProgress = false;
      this.router.navigate([
        '/documents/e-consultations/response',
        {
          referralId: ref.id,
          patientIdentifier: asPipe(referral.subject.identifiers[0]),
        },
      ]);
    });
  }
}
